module.exports = __webpack_public_path__ + "static/media/mediumTarget.5151ec59.svg";